import { defineStore } from "pinia";
import { ref } from "vue";
import type { Flag } from "./flag";

export const useFeatureFlagStore = defineStore("module:feature-flag", () => {
  const flags = ref<Partial<Record<Flag, boolean>>>({});

  const setFlag = (flag: Flag, value: boolean) => {
    flags.value = {
      ...flags.value,
      [flag]: value,
    };
  };

  const isFlagEnabled = (flag: Flag) => {
    return flags.value[flag] ?? false;
  };

  return {
    flags,
    isFlagEnabled,
    setFlag,
  };
});
